import React from 'react';
import Navbar from './components/Navbar/Navbar';
import HeroSlider from './components/HeroSlider/HeroSlider';
import ContentLayout from './components/ContentLayout/ContentLayout';
import Modal from './components/Modal/Modal';
import PopupForm from './components/PopupForm/PopupForm';
import Footer from './components/Footer/Footer';
import { useState } from 'react';
import './App.css';

function triggerDownload(url, filename) {
  const a = document.createElement('a');
  a.href = url;
  if (filename) a.download = filename; // suggest filename
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function App() {

  const [modalOpen, setModalOpen] = useState(false);
  const [intent, setIntent] = useState(null);
  const handleEnquireNow = () => {
    setIntent({ type: 'enquiry' });
    setModalOpen(true);
  };
  const handleRequestBrochure = (url, filename) => {
    setIntent({ type: 'download', url, filename });
    setModalOpen(true);
  };

  const handleFormSuccess = () => {
    if (intent?.type === 'download' && intent.url) {
      triggerDownload(intent.url, intent.filename || 'Brochure.pdf');
    }
    setIntent(null);
    setModalOpen(false);
  };

  return (
    <div className="App">
      <Navbar onEnquire={handleEnquireNow} />
      <HeroSlider />
      <ContentLayout onRequestBrochure={handleRequestBrochure} />
      <Footer />
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} ariaLabel="Lead form">
        <PopupForm onSuccess={handleFormSuccess} />
      </Modal>
    </div>
  );
}

export default App;
